<table
  class="details-table"
  *ngIf="job">
  <tr
    *ngIf="
      (job.organisation.address &&
        (job.organisation.address.street ||
          job.organisation.address.zip ||
          job.organisation.address.location)) ||
      job.department.phone
    ">
    <td class="detail-label">{{ ("details" | i18n) || "Details" }}</td>
    <td>
      {{
        job.organisation.address?.street
          ? job.organisation.address?.street + ", "
          : ""
      }}
      {{
        job.organisation.address?.zip ? job.organisation.address?.zip + " " : ""
      }}
      {{
        job.organisation.address?.location
          ? job.organisation.address?.location
          : ""
      }}
      {{
        !job.department.phone
          ? ""
          : job.organisation.address
          ? " | " + job.department.phone
          : job.department.phone
      }}
    </td>
  </tr>
  <tr *ngIf="job.caseNumber">
    <td class="detail-label">{{ ("caseNumber" | i18n) || "Fallnummer" }}</td>
    <td>{{ job.caseNumber }}</td>
  </tr>
  <tr *ngIf="job.description">
    <td class="detail-label">{{ ("description" | i18n) || "Beschreibung" }}</td>
    <td>{{ job.description }}</td>
  </tr>
  <tr *ngIf="job?.jobType !== undefined">
    <td class="detail-label">{{ ("jobType" | i18n) || "Dienstart" }}</td>
    <td>
      {{ ("jobTypeEnum." + (job?.jobType || "") | i18n) || "" }}
    </td>
  </tr>
  <tr *ngIf="job?.yourself?.customer?.displayName">
    <td class="detail-label">
      {{ ("offerFrom" | i18n) || "Angebot von" | titlecase }}
    </td>
    <td data-cy="customer-name-text">
      {{ job?.yourself?.customer?.displayName }}
    </td>
  </tr>
  <tr *ngIf="jobCertificates$ | async as certificatesString">
    <td class="detail-label">
      {{ ("certificates" | i18n) || "Qualifikation" | titlecase }}
    </td>
    <td>{{ certificatesString }}</td>
  </tr>
  <tr
    *ngFor="
      let row of (nonDefaultCustomCriteriaRows$ | async) || [];
      trackBy: trackByCustomCriteriaLabel
    ">
    <td class="detail-label">{{ row.label }}</td>
    <td>
      <ng-container *ngIf="row.toggleValue !== undefined">
        {{ (row.toggleValue ? "yes" : "no") | i18n }}
      </ng-container>
      <ng-container *ngIf="row.toggleValue === undefined">
        {{ row.selectText }}
      </ng-container>
    </td>
  </tr>
</table>
